import { useState } from "react";
import Pagination from "react-js-pagination";
import useConfiguration from "../../hooks/useConfiguration";
import { deleteInboxMsgData, updateArchiveStatus, updateInboxStatus } from "./action";
import { useDispatch } from "react-redux";
import { Collapse } from "react-bootstrap";
import './index.css';
import Maps from './Maps'
import Modal from '../common/Modal/modal';
import { getNotificationCounts } from '../NotificationHeader/action';

const Inbox = ({
  content,
  isOpen,
  toggle,
  removeInboxMsg,
  inboxStatusHandler,
  archievedNotificationHandler
}) => {

  const [openMap, setOpenMap] = useState({ flag: false, lat: '', lng: '' });
  const config = useConfiguration();

  const triggerMap = (mapData) => {
    if (mapData?.lat && mapData?.lng) {
      setOpenMap({ flag: true, lat: mapData?.lat, lng: mapData?.lng })
    }

  }

  const closeMap = () => {
    setOpenMap({ flag: false, lat: '', lng: '' })
  }

  return (
    <div className="border-bottom">
      {
        openMap?.flag && <Modal showHide={closeMap} label={"Map"} onlyClose={true}>
          <Maps
            googleMapURL={config.mapURL}
            containerElement={<div style={{ height: '400px' }} />}
            mapElement={<div style={{ height: '100%' }} />}
            loadingElement={<div style={{ height: `100%` }} />}
            lat={openMap?.lat}
            lng={openMap?.lng}
          />
        </Modal>
      }
      <div className="table-responsive">
        <table
          className="table dataTable no-footer girdtable table-borderless"
          role="grid"
          aria-describedby="myTable_info"
        >
          <tbody>
            <tr className="">
              <td className="col-3">
                <div class="d-flex align-items-center">
                  <span onClick={toggle} role="button" className="me-2">
                    {isOpen ? (
                      <i
                        class="fa fa-angle-down"
                        style={{ fontSize: "24px" }}
                      ></i>
                    ) : (
                      <i
                        onClick={() => {
                          if (content?.isRead !== 1) {
                            inboxStatusHandler({
                              status: 1,
                              notifyId: content?.incidentReportingId
                            });
                          }
                        }}
                        class="fa fa-angle-right"
                        style={{ fontSize: "24px" }}
                      ></i>
                    )}
                  </span>
                  {content?.isRead !== 1 && (
                    <span
                      className="text-center bg-danger text-white rounded-2 p-1 me-2 "
                      style={{ fontSize: "10px" }}
                    >
                      New
                    </span>
                  )}
                  <span className="d-flex flex-column ">
                    <span>{content?.candidateName}</span>
                    {/* <span>{content?.candidateEmail}</span> */}
                  </span>
                </div>
              </td>
              <td className="col-2" >
                {content?.locationName}
              </td>
              <td className="col-1">
                <span onClick={() => triggerMap({ lat: parseFloat(content?.latitude), lng: parseFloat(content?.longitude) })}><i class="fa fa-map-marker green-icon"></i></span>
                {/* <div className="d-flex flex-column">
                  <span> Latitude : {content?.latitude}</span>
                  <span> Longitude: {content?.longitude}</span>
                </div> */}
              </td>
              {/* <td className="col-2">
                {content?.incidentReport}
              </td> */}
              <td className="col-2">
                Incident report submitted on {content?.reportingDate}
              </td>
              <td className="col-2" >
                {content?.isRead === 1 ? (
                  <span
                    onClick={() =>
                      inboxStatusHandler({
                        status: 0,
                        notifyId: content?.incidentReportingId
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-envelope-open fa-lg text-primary"></i>{" "}
                    Resolved
                  </span>
                ) : (
                  <span
                    onClick={() =>
                      inboxStatusHandler({
                        status: 1,
                        notifyId: content?.incidentReportingId,
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <i class="bi bi-envelope fa-lg text-primary"></i> Mark as Resolved
                  </span>
                )}
              </td>
             


              <td className="col-2" >
                {content?.isArchived ? (
                  <span
                    onClick={() =>
                      archievedNotificationHandler({
                        status: 0,
                        notifyId: content?.incidentReportingId
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fa fa-archive fa-lg text-primary"></i>{" "}
                    Unarchive
                  </span>
                ) : (
                  <span
                    onClick={() =>
                      archievedNotificationHandler({
                        status: 1,
                        notifyId: content?.incidentReportingId,
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <i class="fa fa-archive fa-lg text-primary"></i> Archive
                  </span>
                )}
              </td>

              <td className="col-1">
                <i style={{ cursor: "pointer", fontSize: "1rem" }}
                  onClick={() => removeInboxMsg(content.incidentReportingId)} 
                  class="text-primary fe fe-trash-2" ></i>
              </td>



              {/* <td className="col-1">
                <i
                  style={{ cursor: "pointer", fontSize: "1rem" }}
                  onClick={() => removeInboxMsg(content.messageId)}
                  class="text-primary fe fe-trash-2"
                ></i>
              </td> */}
            </tr>
          </tbody>
        </table>
      </div>

      {/* details */}
      <Collapse in={isOpen} className="content">
        <div className="row mt-3 ms-4">
          <span className="fw-bolder">
            <h4>Incident Report Info</h4>
          </span>

          <div className="row">
            {/* <div dangerouslySetInnerHTML={{ __html: content?.message }}></div> */}
            <span className="d-flex flex-column">
              <span>Shift Start Date: {content?.shiftDateTimeToDisplay}</span>
              <span> Shift Start Time: {content?.startTime}</span>
              <span> Shift End Time: {content?.endTime}</span>
            </span>
            <div className="d-flex flex-column">
              <span> Latitude : {content?.latitude}</span>
              <span> Longitude: {content?.longitude}</span>
            </div>
            <label>Report :</label>
            <span>{content?.incidentReport}</span>
          </div>
          {/* {content?.messageTrackingAttachments
            ?.length > 0
            ? content?.messageTrackingAttachments?.map(
              (item) => {
                return (
                  <span
                    rel="noreferrer"
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      downloadUploadDoc(
                        item?.azureBlobName,
                        item?.messageTrackingAttachmentId,
                        {
                          url: "Messaging/download-Message-file-tracking-document?MessageTrackingAttachmentId=",
                        }
                      )
                    }
                  >
                    <i>
                      {item?.azureBlobName} -
                    </i>
                    <i
                      className="mdi mdi-arrange-bring-forward"
                      data-bs-toggle="tooltip"
                      title=""
                      data-bs-original-title="mdi-arrange-bring-forward"
                      aria-label="mdi-arrange-bring-forward"
                    ></i>
                  </span>
                );
              }
            )
            : ""} */}
        </div>
      </Collapse>
    </div>
  );
};

const AccordianTable = (props) => {
  const { handlePageChange, currentPage, pageSize, totalCount, handlePageSize } = props;
  const [isOpen, setIsOpen] = useState(null);
  const config = useConfiguration();
  const dispatch = useDispatch()

  const toggleOpen = (id) => () => {
    setIsOpen((isOpen) => (isOpen === id ? null : id));
  };


  const inboxStatusHandler = ({ status, notifyId }) => {
    const inboxStatusParams = {
      "incidentReportingId": notifyId,
      "markAsMessageRead": status
    }
    dispatch(updateInboxStatus({
      url: config.baseUrl,
      inboxStatusParams
    })).then(() => {
      dispatch(getNotificationCounts(config.baseUrl))
    })
  };


  const archievedNotificationHandler = ({ status, notifyId }) => {
    const inboxStatusParams = {
      "incidentReportingId": notifyId,
      "isArchived": status
    }
    dispatch(updateArchiveStatus({
      url: config.baseUrl,
      inboxStatusParams
    })).then(() => {
      dispatch(getNotificationCounts(config.baseUrl))
    })
  };



  const removeInboxMsg = inboxMsgId => {
    dispatch(deleteInboxMsgData({
      url: config.baseUrl,
      inboxMsgId: inboxMsgId
    }))
  }
  return (
    <div className="card">
      <div className="card-header">
        <div className="col-lg-4 col-md-4">
          <h5 className="card-title">Incident Report</h5>
        </div>
      </div>
      <div className="card-body">
        <div className="d-inline-flex align-items-center ">
          <label class="mb-0 pe-2">Show</label>
          <select
            name="myTable_length"
            class="form-control form-select"
            value={pageSize}
            aria-controls="myTable"
            onChange={(e) => handlePageSize(Number(e.target.value))}
          >
            {[10, 25, 50, 100].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
          <span className="Entries"> entries</span>
        </div>
        {props.inboxData &&
          props.inboxData.length > 0 &&
          props.inboxData.map((item, index) => (
            <Inbox
              key={index}
              content={item}
              isOpen={isOpen === index}
              toggle={toggleOpen(index)}
              removeInboxMsg={removeInboxMsg}
              inboxStatusHandler={inboxStatusHandler}
              archievedNotificationHandler = {archievedNotificationHandler}
            />
          ))}
      </div>
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div
          className="dataTables_info ps-3"
          id="myTable_info"
          role="status"
          aria-live="polite"
        >
          Showing Page{" "}
          <strong>
            {currentPage} of {Math.ceil(totalCount / pageSize)}
          </strong>
        </div>
        <div class="pe-3 mb-4">
          <Pagination
            itemClass="page-item" // add it for bootstrap 4
            linkClass="page-link" // add it for bootstrap 4
            activePage={currentPage}
            itemsCountPerPage={pageSize}
            totalItemsCount={totalCount}
            pageRangeDisplayed={5}
            onChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

export default AccordianTable;
